(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["impact-enquiry"] && !Shopify.designMode) return;
  try {
    function impactApplicationEnquiry() {
  const message = document.querySelector('#ImpactMessage');
  const application = new URLSearchParams(window.location.search).get('application');
  if (message && !message.value.trim() && application) {
    message.value = application.slice(0, 150) + '\n\n';
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', impactApplicationEnquiry);
else impactApplicationEnquiry();
document.addEventListener('shopify:section:load', impactApplicationEnquiry);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["impact-experience-ui"] && !Shopify.designMode) return;
  try {
    // These pure functions are also exercised by the local enquiry regression tests.
function impactEnquirySelection(product, selectedId, quantity) {
  const variant = product.variants.find(item => item.id === String(selectedId || ''))
    || (!selectedId && product.variants.length === 1 ? product.variants[0] : undefined);
  return {
    product: product.title, product_id: product.id, product_url: product.url,
    variant_id: variant ? variant.id : '', variant: variant ? variant.title : '',
    sku: variant && variant.sku != null ? variant.sku : '',
    quantity: /^[1-9]\d*$/.test(String(quantity || '')) ? String(quantity) : ''
  };
}
function impactEnquirySummary(params, labels) {
  const lines = [(params.get('product') || '').slice(0, 4000)];
  const variant = (params.get('variant') || '').slice(0, 250);
  if (variant && variant !== 'Default Title') lines.push(labels.variant + ': ' + variant);
  const sku = (params.get('sku') || '').slice(0, 250);
  if (sku) lines.push(labels.part + ': ' + sku);
  const url = (params.get('product_url') || '').slice(0, 2000);
  // Values go into editable text fields, never HTML or an automatically opened URL.
  if (/^https?:\/\//.test(url)) lines.push(labels.product_url + ': ' + url);
  return lines.filter(Boolean).join('\n');
}
function impactExperience() {
  const labelNode = document.querySelector('#ImpactExperienceLabels');
  if (!labelNode) return;
  const labels = JSON.parse(labelNode.textContent);
  const params = new URLSearchParams(window.location.search);
  const productField = document.querySelector('[data-impact-product]');
  if (productField && !productField.dataset.impactContext) {
    productField.dataset.impactContext = 'true';
    if (!productField.value) productField.value = impactEnquirySummary(params, labels);
    const quantity = document.querySelector('#ImpactQuantity');
    if (quantity && !quantity.value) quantity.value = (params.get('quantity') || '').slice(0, 100);
    for (const key of ['product_id', 'variant_id']) {
      const field = document.querySelector('[data-impact-context="' + key + '"]');
      const value = params.get(key) || '';
      if (field && /^\d+$/.test(value)) field.value = value;
    }
  }
  const contextNode = document.querySelector('#ImpactProductContext');
  if (contextNode && !contextNode.dataset.bound) {
    contextNode.dataset.bound = 'true';
    const product = JSON.parse(contextNode.textContent);
    const updateLink = link => {
      const form = contextNode.closest('[data-section-type="product-page-section"]')?.querySelector('form[action*="/cart/add"]');
      const selected = form?.querySelector('[name="id"]');
      const quantity = form?.querySelector('[name="quantity"]');
      const values = impactEnquirySelection(product, selected?.value, quantity?.value);
      const url = new URL(link.href, window.location.origin);
      Object.entries(values).forEach(([key, value]) => value ? url.searchParams.set(key, value) : url.searchParams.delete(key));
      link.href = url.href;
    };
    const links = () => document.querySelectorAll('[data-impact-enquiry]');
    links().forEach(link => {
      updateLink(link);
      ['click', 'auxclick', 'contextmenu', 'focus', 'pointerdown'].forEach(name => link.addEventListener(name, () => updateLink(link)));
    });
    // Change events keep copy/open-in-new-tab accurate; activation reads again after BOLD settles.
    contextNode.closest('[data-section-type="product-page-section"]')?.addEventListener('change', () => links().forEach(updateLink));
  }
  const header = document.querySelector('#header');
  if (!header || header.dataset.impactAccessible) return;
  header.dataset.impactAccessible = 'true';
  const toggle = header.querySelector('#wsnavtoggle');
  const menu = header.querySelector('.wsmenu');
  const container = header.closest('.wsmenucontainer');
  const phone = window.matchMedia('(max-width:768px)');
  let menuWasOpen = false;
  const visible = element => !!(element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
  const syncMenu = () => {
    const open = phone.matches && !!container?.classList.contains('wsoffcanvasopener');
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
    if (menu) menu.inert = phone.matches && !open;
    if (open && !menuWasOpen) menu?.querySelector('a')?.focus();
    if (!open && menuWasOpen && phone.matches) toggle?.focus();
    menuWasOpen = open;
  };
  if (container && toggle && menu) {
    new MutationObserver(syncMenu).observe(container, {attributes:true, attributeFilter:['class']});
    phone.addEventListener('change', syncMenu);
    syncMenu();
  }
  header.querySelectorAll('[role="button"]').forEach(control => {
    control.addEventListener('keydown', event => {
      if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); control.click(); }
    });
  });
  toggle?.addEventListener('click', event => event.preventDefault());
  header.querySelectorAll('[data-impact-account]').forEach(control => {
    const wrapper = control.closest('li');
    const panel = wrapper.querySelector('.dropdown-grid-wrapper');
    let wasOpen = false;
    const sync = () => {
      const open = wrapper.classList.contains('open');
      control.setAttribute('aria-expanded', String(open));
      if (panel) panel.inert = !open;
      if (open && !wasOpen) panel?.querySelector('input:not([type="hidden"]), a, button')?.focus();
      wasOpen = open;
    };
    new MutationObserver(sync).observe(wrapper, {attributes:true, attributeFilter:['class']});
    sync();
  });
  // Legacy cart modal owns its content and focus trap; reflect its real open state.
  let cartTrigger = null;
  header.querySelectorAll('.cart-popup').forEach(control => control.addEventListener('click', () => { cartTrigger = control; }, true));
  if (window.jQuery) {
    window.jQuery(document).on('mfpOpen.impactHeader', () => {
      if (cartTrigger && document.querySelector('.mfp-content .cart_menu')) cartTrigger.setAttribute('aria-expanded', 'true');
    }).on('mfpClose.impactHeader', () => {
      if (cartTrigger) { cartTrigger.setAttribute('aria-expanded', 'false'); cartTrigger.focus(); cartTrigger = null; }
    });
  }
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const account = header.querySelector('li.open [data-impact-account]');
      if (account) { event.preventDefault(); account.click(); account.focus(); }
      else if (menuWasOpen) { event.preventDefault(); toggle.click(); }
    }
    if (event.key === 'Tab' && menuWasOpen) {
      const stops = [toggle, ...menu.querySelectorAll('a[href], [tabindex="0"]')].filter(visible);
      const index = stops.indexOf(document.activeElement);
      if (event.shiftKey && index <= 0) { event.preventDefault(); stops[stops.length - 1]?.focus(); }
      else if (!event.shiftKey && (index === stops.length - 1 || index < 0)) { event.preventDefault(); stops[0]?.focus(); }
    }
  });
  // The legacy menu inserts its disclosure arrows during window load.
  const enhanceArrows = () => header.querySelectorAll('.wsmenu-click,.wsmenu-click02').forEach((control, index) => {
    if (control.dataset.impactAccessible) return;
    control.dataset.impactAccessible = 'true';
    const parent = control.parentElement;
    const link = parent.querySelector(':scope > a, :scope > h5 a');
    const panel = parent.querySelector(':scope > ul, :scope > .megamenu');
    if (!link || !panel) return;
    if (!panel.id) panel.id = 'ImpactSubmenu-' + index;
    control.setAttribute('role', 'button'); control.tabIndex = 0;
    control.setAttribute('aria-label', labels.submenu + ' ' + link.textContent.trim());
    control.setAttribute('aria-controls', panel.id);
    control.querySelectorAll('i').forEach(icon => icon.setAttribute('aria-hidden', 'true'));
    const sync = () => control.setAttribute('aria-expanded', link.getAttribute('aria-expanded') || 'false');
    new MutationObserver(sync).observe(link, {attributes:true, attributeFilter:['aria-expanded']});
    sync();
    control.addEventListener('keydown', event => {
      if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); control.click(); }
    });
  });
  enhanceArrows();
  window.addEventListener('load', enhanceArrows, {once:true});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', impactExperience);
else impactExperience();
document.addEventListener('shopify:section:load', impactExperience);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["impact-filter-normalisation"] && !Shopify.designMode) return;
  try {
    function impactNormaliseImpedanceFilter() {
  const path=decodeURI(window.location.pathname);
  if(!path.startsWith('/collections/'))return;
  const normalised=path.replace(/impedance_8-[ωΩ]/g,'impedance_8-ohm');
  if(normalised!==path){const url=new URL(window.location.href);const parts=normalised.split('/');parts[parts.length-1]=[...new Set(parts[parts.length-1].split('+'))].join('+');url.pathname=parts.join('/');url.searchParams.delete('page');window.location.replace(url.href);return;}
  document.querySelectorAll('.advanced-filters').forEach(group=>{
    const canonical=group.querySelector('[data-handle="impedance_8-ohm"]');
    if(canonical)group.querySelectorAll('[data-handle="impedance_8-ω"],[data-handle="impedance_8-Ω"]').forEach(item=>item.remove());
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',impactNormaliseImpedanceFilter);else impactNormaliseImpedanceFilter();
document.addEventListener('shopify:section:load',impactNormaliseImpedanceFilter);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["impact-store-styles"] && !Shopify.designMode) return;
  try {
    function impactStoreEnhance() {
  document.querySelectorAll('.pro_main_c .qty a[role="button"]').forEach(control => {
    if (control.dataset.impactKeyboard) return;
    control.dataset.impactKeyboard = 'true';
    control.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault(); control.click();
      }
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', impactStoreEnhance);
else impactStoreEnhance();
document.addEventListener('shopify:section:load', impactStoreEnhance);
  } catch(e) { console.error(e); }
})();

})();
